import { Pipe, PipeTransform } from '@angular/core';
import { OperationRuleDto } from '@clearing-hub/common';

@Pipe({
  name: 'valueRulePipe',
  standalone: true
})
export class ValueRulePipe implements PipeTransform {
  transform(key: string, value: number, rules: Record<string, OperationRuleDto>) {
    if (rules && rules[key]) {
      if (rules[key].operation === 'divide') {
        return value / rules[key].value;
      }
      if (rules[key].operation === 'multiply') {
        return value * rules[key].value;
      }
    }
    return value;
  }
}
